import * as React from 'react'
import DonateIcon from '../images/icons/donate-icon'
import FundIcon from '../images/icons/fund-icon'
import HelpIcon from '../images/icons/help-icon'
import InvestIcon from '../images/icons/invest-icon'
import LearnIcon from '../images/icons/learn-icon'
import OutreachIcon from '../images/icons/outreach-icon'
import PurchaseIcon from '../images/icons/purchase-icon'
import VolunteerIcon from '../images/icons/volunteer-icon'
import { LocationType } from '../types/location-types'

export const EVERY_DONATION_ACTION_SUFFIX = '--every-donation'
export const GIVE_LIVELY_DONATION_ACTION_SUFFIX = '--give-lively-donation'

export const ctaLabelsByCategory = {
  'be-heard': 'Learn More'
}

export const ctaIconsByCategory = {
  'learn': <LearnIcon />,
  'get-educated': <LearnIcon />,
  volunteer: <VolunteerIcon />,
  purchase: <PurchaseIcon />,
  invest: <InvestIcon />,
  'get-help': <HelpIcon />,
  'get-funded': <FundIcon />,
  fundraise: <DonateIcon />,
  donate: <DonateIcon />,
  'be-heard': <OutreachIcon />
}
export enum OutreachRepresentative {
  SENATORS = 'senators',
  REPRESENTATIVES = 'representatives',
  GOVERNOR = 'governor',
  STATE_SENATORS = 'stateSenators',
  STATE_REPRESENTATIVES = 'stateRepresentatives',
  MAYOR = 'mayor',
  CITY_COUNCIL = 'cityCouncil',
  SCHOOL_BOARD = 'schoolBoard',
  OTHER = 'other'
}

export const representativeLabels = {
  [OutreachRepresentative.SENATORS]: 'U.S. Senator',
  [OutreachRepresentative.REPRESENTATIVES]: 'U.S. Representative',
  [OutreachRepresentative.GOVERNOR]: 'Governor',
  [OutreachRepresentative.STATE_SENATORS]: 'State Senators',
  [OutreachRepresentative.STATE_REPRESENTATIVES]: 'State Representatives',
  [OutreachRepresentative.MAYOR]: 'Mayor',
  [OutreachRepresentative.CITY_COUNCIL]: 'City Council',
  [OutreachRepresentative.SCHOOL_BOARD]: 'School Board',
  [OutreachRepresentative.OTHER]: 'Other'
}

export const representativeToLocationTypeMap: Record<OutreachRepresentative, LocationType> = {
  [OutreachRepresentative.SENATORS]: 'federal',
  [OutreachRepresentative.REPRESENTATIVES]: 'federal',
  [OutreachRepresentative.GOVERNOR]: 'state',
  [OutreachRepresentative.STATE_SENATORS]: 'state',
  [OutreachRepresentative.STATE_REPRESENTATIVES]: 'state',
  [OutreachRepresentative.MAYOR]: 'city',
  [OutreachRepresentative.CITY_COUNCIL]: 'city',
  [OutreachRepresentative.SCHOOL_BOARD]: 'city',
  [OutreachRepresentative.OTHER]: 'local'
}

export const getActionCtaLabelByCategory = (category?: Queries.SanityCategory) => {
  return ctaLabelsByCategory[category?.slug?.current] || category?.title
}

export const getActionCtaIconByCategory = (category?: Queries.SanityCategory) => {
  return ctaIconsByCategory[category?.slug?.current]
}

export const getActionCtaIconByString = (category?: string) => {
  return ctaIconsByCategory[category]
}
